import React__default from 'react';
import { Tooltip } from '@grandvisionhq/common';
import { RadioButtons } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';

var OpticianType;
(function(OpticianType) {
    OpticianType["Internal"] = 'internal';
    OpticianType["External"] = 'external';
})(OpticianType || (OpticianType = {}));
const Optician = ({ selectedOpticianType , onOpticianTypeChange , opticianForm: OpticianForm ,  })=>{
    const { getLabel  } = useIntl();
    const radioOptions = React__default.useMemo(()=>[
            {
                value: OpticianType.Internal,
                label: getLabel('products.contactLens.info.optician.internal')
            },
            {
                value: OpticianType.External,
                label: getLabel('products.contactLens.info.optician.external')
            }, 
        ]
    , [
        getLabel
    ]);
    const handleRadiosChange = React__default.useCallback(({ value  })=>{
        onOpticianTypeChange(value);
    }, [
        onOpticianTypeChange
    ]);
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "prescription-info-optician"
    }, /*#__PURE__*/ React__default.createElement("span", {
        className: "prescription-info-optician__label"
    }, getLabel('products.contactLens.info.optician.label'), /*#__PURE__*/ React__default.createElement(Tooltip, {
        message: getLabel('products.contactLens.info.optician.hint'),
        id: "validation-optician-tooltip"
    })), /*#__PURE__*/ React__default.createElement(RadioButtons, {
        formName: "optician-type",
        scope: "opticianType",
        alignment: "vertical",
        onChange: handleRadiosChange,
        initialValue: selectedOpticianType,
        items: radioOptions
    }), selectedOpticianType === OpticianType.External && /*#__PURE__*/ React__default.createElement("div", {
        className: "prescription-info-optician__store-form"
    }, OpticianForm));
};
var Optician$1 = Optician;

export { Optician, OpticianType, Optician$1 as default };
//# sourceMappingURL=Optician.js.map
